type Theme = 'light' | 'dark';
type Listener = (theme: Theme) => void;

const STORAGE_KEY = 'app_theme';

function createThemeStore() {
  let theme: Theme = (localStorage.getItem(STORAGE_KEY) as Theme) || 'light';
  const listeners = new Set<Listener>();

  const get = (): Theme => theme;

  const set = (next: Theme) => {
    theme = next;
    localStorage.setItem(STORAGE_KEY, next);
    listeners.forEach(fn => fn(next));
  };

  const toggle = () => set(theme === 'dark' ? 'light' : 'dark');

  const subscribe = (fn: Listener): (() => void) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  };

  return { get, set, toggle, subscribe };
}

export const themeStore = createThemeStore();
export type { Theme };
